import React, { useState } from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthPage from "../layouts/SelfServeAuthPage";
import { Box, TextField, Typography } from "@mui/material";
import Link from "../components/Link";
import { useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import SuccessImage from '../images/success.png';
import { resetPassword } from "../clients/FixieApiClient";

interface FormValues {
  password: string
}

export default () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { register, handleSubmit } = useForm<FormValues>();

  const resetToken = searchParams.get('token');

  if (!resetToken) {
    navigate('/login');
    return null;
  }

  const onSubmit = async (data: FormValues) => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);
    try {
      const response = await resetPassword(data.password, resetToken);
      if (response.ok) {
        setIsSuccess(true);
      }
    } finally {
      setIsLoading(false);
    }
  }

  if (isSuccess) {
    return (
      <AuthPage>
        <Box textAlign="center">
          <img src={SuccessImage} alt="" style={{
            width: '256px',
            height: '256px',
            marginBottom: '1rem'
          }} />
          <Typography variant="body1">Your password has been reset. Please log in.</Typography><br />
          <Link to="/login" variant="body1" style={{ textDecoration: "none" }}>
            Log in
          </Link>
        </Box>
      </AuthPage>
    )
  }

  return (
    <AuthPage>
      <Box>
        <Typography variant="body1">Thank you for verifying your email. Please select a new password.</Typography>
      </Box>
      <Box sx={{ textAlign: "center" }}>
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <TextField
            required
            fullWidth
            margin="normal"
            label="Password"
            type="password"
            variant="outlined"
            {...register("password")}
          />
          <LoadingButton
            loading={isLoading}
            disableElevation
            variant="contained"
            type="submit"
            fullWidth
            sx={{ mt: 2, mb: 2, height: "56px" }}
          >
            <span>Continue</span>
          </LoadingButton>
        </Box>
      </Box>
    </AuthPage >
  );
};
